import { useState } from 'react';
import { Title } from '../components/title';
import { Search } from '../components/home/search';
import { MainNav } from '../components/home/main-nav';
import { X, Menu } from 'lucide-react';
import styles from './help.module.css';

export const Help = () => {
  const [menuActive, setMenuActive] = useState(false);
  return (
    <>
      <Title title="Help" />
      <div className={ styles.layout }>
        <header className={ styles.header }>
          <div data-menu={ menuActive }>
            <h1 className={ styles.siteTitle }>
              <span>
                icklesquishy.bot
              </span>
              <button
                type="button"
                className={ styles.menuButton }
                onClick={ () => setMenuActive(!menuActive) }
              >
                { menuActive ? <X /> : <Menu /> }
                <span className="visually-hidden">Menu</span>
              </button>
            </h1>
            <Search />
            <MainNav />
          </div>
        </header>
        <main className={ styles.main }>
          <div className={ styles.content }>
            <h1 className={ styles.title }>
              Help
            </h1>
            
            <p>
              Admin commands are available in chat using the <code>!squish admin</code> command.
            </p>
            
            <p>
              Configure browser views in OBS. All urls are configured with URL parameters e.g. <code>https://icklequishy.bot/app?view=notifications&debug=false</code>.
            </p>

            <hr />

            <h2>
              Notifications
            </h2>
            <pre>
              https://icklequishy.bot/app
            </pre>
            <p>
              Options:
            </p>
            <ul>
              <li>
                <code>duration</code>: <code>number</code> - The duration of the notification in milliseconds. Default is <code>10000</code> (10 seconds).
              </li>
              <li>
                <code>debug</code>: <code>true</code> or <code>false</code> - Show the debug panel
              </li>
            </ul>
            
            <hr />

            <h2>
              Leaderboard
            </h2>
            <pre>
              https://icklequishy.bot/app?view=leaderboard
            </pre>
            <p>
              A square aspect ratio is recommended. e.g. <code>800</code> width and <code>800</code> height.
            </p>
            <p>
              Options:
            </p>
            <ul>
              <li>
                <code>limit</code>: <code>number</code> - The number of users to show. Default is <code>5</code>.
              </li>
              <li>
                <code>type</code>: <code>session</code> or <code>global</code> - The type of leaderboard to show. Default is <code>session</code>.
              </li>
              <li>
                <code>orientation</code>: <code>portrait</code> or <code>landscape</code> - The orientation of the leaderboard. Default is <code>portrait</code>.
              </li>
              <li>
                <code>debug</code>: <code>true</code> or <code>false</code> - Show the debug panel
              </li>
            </ul>

            <hr />

            <h2>
              Gloat
            </h2>
            <pre>
              https://icklequishy.bot/app?view=gloat
            </pre>
            <p>
              Options:
            </p>
            <ul>
              <li>
                <code>debug</code>: <code>true</code> or <code>false</code> - Show the debug panel
              </li>
            </ul>
          </div>
        </main>
      </div>
    </>
  );
};